var map = {
	"./balloon.svg": "a6d7",
	"./balloon_half.svg": "e617",
	"./balloon_ride.svg": "1ea9",
	"./balloon_ride_half.svg": "ae55",
	"./bear.svg": "e2da",
	"./bear_half.svg": "548e",
	"./butterfly.svg": "5e4a",
	"./butterfly_half.svg": "15bf",
	"./car.svg": "3701",
	"./car_half.svg": "500d",
	"./cat.svg": "8a19",
	"./cat_half.svg": "e577",
	"./chicken.svg": "c9c4",
	"./chicken_half.svg": "d0da",
	"./dinosaur.svg": "5203",
	"./dinosaur_half.svg": "7c99",
	"./dog.svg": "d24a",
	"./dog_half.svg": "a954",
	"./donut.svg": "9dcf",
	"./donut_half.svg": "3a27",
	"./elephant.svg": "ed6a",
	"./elephant_half.svg": "7744",
	"./fish.svg": "b02a",
	"./fish_half.svg": "505b",
	"./frog.svg": "405a",
	"./frog_half.svg": "83b5",
	"./fuji.svg": "52d3",
	"./fuji_half.svg": "b512",
	"./goast.svg": "be59",
	"./goast_half.svg": "d1df",
	"./gray.svg": "56c5",
	"./heart.svg": "ebd0",
	"./heart_half.svg": "7d3b",
	"./icecream.svg": "2401",
	"./icecream_half.svg": "b888",
	"./lion.svg": "72ad",
	"./lion_half.svg": "2d3d",
	"./moon.svg": "c2c7",
	"./moon_half.svg": "9f76",
	"./octopus.svg": "21c2",
	"./octopus_half.svg": "0def",
	"./panda.svg": "f22b",
	"./panda_half.svg": "455c",
	"./penguin.svg": "01e7",
	"./penguin_half.svg": "3633",
	"./pudding.svg": "ed5a",
	"./pudding_half.svg": "2307",
	"./rabbit.svg": "02e4",
	"./rabbit_half.svg": "e265",
	"./rainbow.svg": "91a6",
	"./rainbow_half.svg": "3168",
	"./riceball.svg": "50d2",
	"./riceball_half.svg": "ea4e",
	"./robot.svg": "55c2",
	"./robot_half.svg": "fa8e",
	"./rocket.svg": "257c",
	"./rocket_half.svg": "5510",
	"./rose.svg": "65b4",
	"./rose_half.svg": "3956",
	"./ship.svg": "9b2f",
	"./ship_half.svg": "a7a1",
	"./soccer.svg": "2a00",
	"./soccer_half.svg": "c5d9",
	"./sun.svg": "3c2c",
	"./sun_half.svg": "3c4c",
	"./sunflower.svg": "b109",
	"./sunflower_half.svg": "5078",
	"./tiger.svg": "a5e3",
	"./tiger_half.svg": "52f8",
	"./tomato.svg": "2d53",
	"./tomato_half.svg": "a42c",
	"./tulip.svg": "0897",
	"./tulip_half.svg": "a3c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3860";